/**
 * @deprecated This should be removed once we migrate away from using Synchrony
 */
export enum SYNC_STATUS_KEY {
	CONNECTED = 'connected',
	DISCONNECTED = 'disconnected',
	ERROR = 'error',
	COLLAB_LIMIT = 'collab-limit',
	PERMISSION_CHANGED = 'permission-changed',
}

export const DROPBOX_APP_KEY = 'l5albia6lf64r4n';

export const PAGE_HAS_MIGRATED_FEATURE_KEY = 'confluence.fabric.page.optin.page.has.been.migrated';

export const MIGRATION_FLAG_AUTO_CLOSE_TIMEOUT = 8000;

export const learnMoreURL =
	'https://support.atlassian.com/confluence-cloud/docs/convert-pages-to-the-new-editor/#Convertpagestotheneweditor-WhatACTUALLYhappenswhenyourcontentisconverted';
